import httpApi from "@/apis/httpApi";
import http from "@/utils/http.js";

// 禁言用户 、 IP 列表
interface MuteUserListJson {
  token: string;
  type: number;
  page: number;
  limit: number;
  keyword: string;
}
export const muteUserList = (json: MuteUserListJson): any =>
  http.httpGet({
    url: httpApi.live.muteUserList,
    json,
  });

// 查询用户
interface SearchUserJson {
  token: string;
  keyword: string;
}
export const searchUser = (json: SearchUserJson): any =>
  http.httpGet({
    url: httpApi.live.searchUser,
    json,
  });

// 解除禁言记录
interface UnlockMuteListJson {
  token: string;
  page: number;
  limit: number;
}
export const unlockMuteList = (json: UnlockMuteListJson): any =>
  http.httpGet({
    url: httpApi.live.unlockMuteList,
    json,
  });

// 解除禁言记录
interface UnlockMuteJson {
  token: string;
  t_uid: string;
}
export const unlockMute = (json: UnlockMuteJson): any =>
  http.httpPost({
    url: httpApi.live.unlockMute,
    json,
  });

// 禁言观众/添加
interface MuteUserJson {
  token: string;
  t_uids: string;
  type: string;
  ban_duration: string;
  reason: string;
}
export const muteUser = (json: MuteUserJson): any =>
  http.httpPost({
    url: httpApi.live.muteUser,
    json,
  });

// 屏蔽词列表
interface BlackWordsListJson {
  token: string;
}
export const blackWordsList = (json: BlackWordsListJson): any =>
  http.httpGet({
    url: httpApi.live.blackWordsList,
    json,
  });

// 删除屏蔽词
interface DelBlackWordJson {
  token: string;
  ids: string;
}
export const delBlackWord = (json: DelBlackWordJson): any =>
  http.httpPost({
    url: httpApi.live.delBlackWord,
    json,
  });

// 添加直播间屏蔽词
interface AddBlackWordJson {
  token: string;
  word: string;
}
export const addBlackWord = (json: AddBlackWordJson): any =>
  http.httpPost({
    url: httpApi.live.addBlackWord,
    json,
  });

// 收礼列表
interface GiftListJson {
  token: string;
  page: number;
  limit: number;
  begin_time: string;
  end_time: string;
}
export const receivedGiftList = (json: GiftListJson): any =>
  http.httpGet({
    url: httpApi.live.receivedGiftList,
    json,
  });

// 直播间详情
interface LiveDetailJson {
  live_no: number;
  cate_id: number;
  rank: number;
}
export const liveDetail = (json: LiveDetailJson): any =>
  http.httpGet({
    url: httpApi.liveBroadRoom.liveDetail,
    json,
  });

// 观众进入直播间
interface EnterLiveRoomJson {
  live_id: number;
}
export const enterLiveRoom = (json: EnterLiveRoomJson): any =>
  http.httpGet({
    url: httpApi.liveBroadRoom.enterLiveRoom,
    json,
  });

// 文本消息-发送文本消息
interface SendTextMessageJson {
  target_type: string;
  target_id: string;
  message: string;
}
export const sendTextMessage = (json: SendTextMessageJson): any =>
  http.httpPost({
    url: httpApi.liveBroadRoom.sendTextMessage,
    json,
  });

// 赠送礼物
interface GiveGiftJson {
  t_uid: string;
  gift_id: string;
  count: string;
  scene_type: string;
  scene_id: string;
}
export const giveGift = (json: GiveGiftJson): any =>
  http.httpPost({
    url: httpApi.liveBroadRoom.giveGift,
    json,
  });

// 关注/取关
interface DoFollowJson {
  t_uid: string;
  status: string;
}
export const doFollow = (json: DoFollowJson): any =>
  http.httpPost({
    url: httpApi.live.doFollow,
    json,
  });

// 结束界面直播推荐
interface RecommendLiveJson {
  game_id: string;
  game_server: string;
  tag: string;
  version_id: string;
}
export const recommendLive = (json: RecommendLiveJson): any =>
  http.httpGet({
    url: httpApi.liveBroadRoom.recommendLive,
    json,
  });

// 观众退出直播间
interface EnterLiveRoomJson {
  live_no: number;
}
export const quitLiveRoom = (json: EnterLiveRoomJson): any =>
  http.httpGet({
    url: httpApi.liveBroadRoom.quitLiveRoom,
    json,
  });
